<template>

    <div id="register">
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row justify-content-between">
                <div class="d-none d-xl-block col-3">
                    <catalog-categories></catalog-categories>
                </div>

                <div class="col-md-6">
                    <h1 class="as-h2 mb-64">Регистрация</h1>

                    <div class="position-relative">
                        <!-- *** STEP 1 *** -->
                        <div v-if="step_1">
                            <div class="mb-32 input-box">
                                <label for="register_phone" :class="{'error-form': $v.login.$error}">Введите номер
                                    телефона*</label>
                                <input id="register_phone" type="text"
                                       placeholder="+"
                                       @input="delayTouch($v.login)"
                                       v-on:keyup.enter="registerStep_1()"
                                       v-mask="'+################'"
                                       v-model.trim="login"
                                >
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте
                                        формат введенного номера.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле
                                        обязательно для заполнения</div>
                                </div>
                            </div>

                            <div class="mb-32 checkbox" :class="{'error-form': $v.register_confirm.$error}">
                                <input id="register_confirm" type="checkbox"
                                       @input="delayTouch($v.register_confirm)"
                                       v-model.trim="register_confirm">
                                <label for="register_confirm">Я соглашаюсь на <router-link to="/rules/publichnaya-oferta" class="text-underline">условие проката</router-link></label>
                            </div>

                            <div class="mb-32 checkbox" :class="{'error-form': $v.register_confirm_agree.$error}">
                                <input id="register_confirm_agree" type="checkbox"
                                       @input="delayTouch($v.register_confirm_agree)"
                                       v-model.trim="register_confirm_agree">
                                <label for="register_confirm_agree">Я даю согласие на <router-link to="/rules/obrabotka-personalnykh-dannykh " class="text-underline">обработку персональных данных</router-link></label>
                            </div>

                            <button class="button btn-large" @click="registerStep_1()" id="kod">Получить код</button>
                        </div>

                        <!-- *** STEP 2 *** -->
                        <div v-if="step_2">
                            <div class="mb-32 input-box">
                                <label for="register_phone_step_2" :class="{'error-form': $v.login.$error}">Введите
                                    номер телефона*</label>
                                <input id="register_phone_step_2" type="text"
                                       placeholder="+"
                                       @input="delayTouch($v.login)"
                                       v-model.trim="login"
                                       v-mask="'+################'">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.minLength">Проверьте
                                        формат введенного номера.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.login.$error && !$v.login.required">Поле
                                        обязательно для заполнения</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="register_code" :class="{'error-form': $v.code.$error}">Введите код, который
                                    пришел на ваш номер*</label>
                                <input id="register_code" type="text"
                                       @input="delayTouch($v.code)"
                                       v-model.trim="code"
                                       v-on:keyup.enter="registerStep_2()">
                                <div class="h6 mb-0 color-text-grey pt-1">Ваш код придет на номер {{login}} в течение 12
                                    сек.</div>
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.code.$error && !$v.code.required">Поле
                                        обязательно для заполнения</div>
                                </div>
                            </div>

                            <button class="button btn-large" @click="registerStep_2()">Отправить</button>
                        </div>

                        <!-- *** STEP 3 *** -->
                        <div v-if="step_3">
                            <div class="input-box mb-32">
                                <label>Выберите, кто Вы*</label>
                                <multiselect v-model="type"
                                             :options="type_options"
                                             selectedLabel=""
                                             selectLabel=""
                                             placeholder=""
                                             deselectLabel=""
                                             :allowEmpty="false"
                                             :searchable="false">
                                </multiselect>
                            </div>


                            <div class="mb-32 input-box">
                                <label for="card_fio" :class="{'error-form': $v.fio.$error}">
                                    <span v-if="type === 'Физическое лицо'">ФИО*</span>
                                    <span v-else>Наименование*</span>
                                </label>
                                <input id="card_fio" type="text"
                                       @input="delayTouch($v.fio)"
                                       v-model.trim="fio"
                                       v-on:keyup.enter="registerStep_3()">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.fio.$error && !$v.fio.required">Поле
                                        обязательно для заполнения</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="card_email" :class="{'error-form': $v.email.$error}">
                                    <span>E-mail*</span>
                                </label>
                                <input id="card_email" type="email"
                                       @input="delayTouch($v.email)"
                                       v-model.trim="email"
                                       v-on:keyup.enter="registerStep_3()">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.email.$error && !$v.email.required">Поле обязательно для заполнения</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.email.$error && $v.email.required && !$v.email.email">Неверный формат</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="register_pass" :class="{'error-form': $v.password.$error}">Введите
                                    пароль*</label>
                                <input id="register_pass" type="password"
                                       v-on:keyup.enter="registerStep_3()"
                                       @input="delayTouch($v.password)"
                                       v-model.trim="password">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.minLength">
                                        Пароль должен содержать не менее 8 знаков.</div>
                                    <div class="h6 pt-1 error-form" v-if="$v.password.$error && !$v.password.required">Поле
                                        обязательно для заполнения.</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="register_pass_repeat" :class="{'error-form': $v.password_confirm.$error}">Введите
                                    пароль повторно*</label>
                                <input id="register_pass_repeat" type="password"
                                       v-on:keyup.enter="registerStep_3()"
                                       @input="delayTouch($v.password_confirm)"
                                       v-model.trim="password_confirm">
                                <div class="error-box">
                                    <div class="h6 pt-1 error-form"
                                        v-if="$v.password_confirm.$error && !$v.password_confirm.minLength">Пароли не
                                        совпадают.</div>
                                    <div class="h6 pt-1 error-form"
                                        v-if="$v.password_confirm.$error && !$v.password_confirm.required">Поле
                                        обязательно для заполнения.</div>
                                </div>
                            </div>

                            <div class="mb-32 input-box">
                                <label for="card_code">
                                    <span>Реферальный код. <a href="/promotions/zarabatyvaite-vmeste-s-myrental" class="color-primary" target="_blank">Подробнее</a></span>
                                </label>
                                <input id="card_code" type="text"
                                       v-model.trim="ref_code"
                                       v-on:keyup.enter="registerStep_3()">
                            </div>

                            <button class="button btn-large" @click="registerStep_3()">Зарегистрироваться</button>
                        </div>

                        <div v-if="loading" class="loading-box">
                            <b-spinner></b-spinner>
                        </div>
                    </div>

                </div>

                <div class="d-none d-md-block text-right col-5 col-lg-3">
                    <img :src="logoSvg"
                         alt="Фотопрокат MRental - прокат фото, видео и кинотехники в Минске без залога"
                         class="img-fluid">
                </div>
            </div>
        </div>

    </div>

</template>


<script>
    import Multiselect from 'vue-multiselect';
    import {
        phoneRule, passwordRule, passwordRepeatRule, checkbox, requiredRule, emailReqRule
    } from '../../../services/validation';

    const touchMap = new WeakMap();

    export default {
        components: {Multiselect},
        data() {
            return {
                clicks: 0,
                login: null,
                password: null,
                password_confirm: null,
                code: null,
                ref_code: null,

                type: 'Физическое лицо',
                email: null,
                fio: null,

                register_confirm: false,
                register_confirm_agree: false,
                logoSvg: require('./../../../../svg/logo-new-dark-2.svg'),

                breadcrumb: [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: 'Регистрация',
                        active: true
                    }
                ],

                type_options: ['Физическое лицо', 'Юридическое лицо'],

                step_1: true,
                step_2: false,
                step_3: false,

                loading: false,
            }
        },
        mounted(){
            this.getSeoInfo();
            this.setRefCode();
        },
        methods: {
            setRefCode() {
                let url = new URL(window.location);
                this.ref_code = url.searchParams.get("code");
            },
            registerStep_1() {
                this.$v.login.$touch();
                this.$v.register_confirm.$touch();
                this.$v.register_confirm_agree.$touch();
                if (this.$v.login.$invalid || this.$v.register_confirm.$invalid || this.$v.register_confirm_agree.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;
                    let url = '/api/register/send-pin';
                    let params = {
                        phone: this.login
                    };
                    axios.post(url, params)
                        .then(response => {
                            if (response.status == 200) {
                                this.step_1 = false;
                                this.step_2 = true;
                                this.loading = false;
                            }
                        })
                        .catch(error => {
                            if (error) this.loading = false;
                        })
                }
            },

            registerStep_2() {
                this.$v.login.$touch();
                this.$v.code.$touch();
                if (this.$v.login.$invalid || this.$v.code.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.loading = true;
                    let url = '/api/register/check-pin';
                    let params = {
                        phone: this.login,
                        pin: this.code
                    };
                    axios.post(url, params)
                        .then(response => {
                            if (response.status == 200) {
                                this.step_2 = false;
                                this.step_3 = true;
                                this.loading = false;
                            }
                        })
                        .catch(error => {
                            if (error) this.loading = false;
                        })
                }
            },
            register(bonuses) {
                let url = '/api/register/register-account';

                let params = {
                    phone: this.login,
                    password: this.password,
                    password_confirm: this.password_confirm,
                    type: this.type,
                    fio: this.fio,
                    email: this.email,
                    ref_code: this.ref_code,
                };
                axios.post(url, params)
                    .then(response => {
                        if (response.status == 200) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Поздравляем!',
                                html: `<span>Вы успешно зарегистрировались на сервисе MRental!</span><br>`,
                                               // <span>На ваш баланс зачислено</span><br>
                                               // <span style="color:#fce01b;" class="h2">` + bonuses + ` Баллов (RUB)</span>`,
                            }).then(() => {
                                if (response.data.access_token) localStorage.setItem('token', response.data.access_token);
                                window.location.pathname = "/account";
                            })
                        }
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
                    .finally(() => {
                        this.clicks = 0;
                    })
            },
            registerStep_3() {
                this.$v.password.$touch();
                this.$v.password_confirm.$touch();
                this.$v.fio.$touch();
                this.$v.email.$touch();
                if (this.$v.fio.$invalid || this.$v.email.$invalid || this.$v.password.$invalid || this.$v.password_confirm.$invalid) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Ошибка',
                        html: 'Проверьте правильность внесенных данных',
                    });
                    return false;
                } else {
                    this.clicks += 1;
                    if (this.clicks === 1) {
                        this.loading = true;
                        axios.post('/api/ref-code-value', { ref_code: this.ref_code })
                            .then(response => {
                               this.register(response.data.bonuses);
                            })
                            .catch(error => {
                                this.register(100);
                            })
                    }
                }
            },

            delayTouch($v) {
                $v.$reset();
                if (touchMap.has($v)) {
                    clearTimeout(touchMap.get($v))
                }
                touchMap.set($v, setTimeout($v.$touch, 1000))
            },

            getSeoInfo(){
                let url = '/api/seo';

                let params = {
                    url: 'register',
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Регистрация на сайте Фотопроката "MRental"';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Зарегистрируйтесь в личном кабинете на сайте Фотопроката "MRental" для контроля своих заказов и управление карточкой клиента. ';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            }
        },

        validations: {
            login: phoneRule,
            password: passwordRule,
            password_confirm: passwordRepeatRule,
            code: requiredRule,
            register_confirm: checkbox,
            register_confirm_agree: checkbox,
            type: requiredRule,
            email: emailReqRule,
            fio: requiredRule
        }

    }
</script>
